module.exports = __webpack_public_path__ + "img/koekjesdeeg-op-bakplaat.2182dac1.jpg";